import { render } from "./PostImagesComponent.vue?vue&type=template&id=4449d39d"
import script from "./PostImagesComponent.vue?vue&type=script&lang=js"
export * from "./PostImagesComponent.vue?vue&type=script&lang=js"

import "./PostImagesComponent.vue?vue&type=style&index=0&id=4449d39d&lang=css"

import exportComponent from "C:\\agilS\\agil.webgisprod\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__